import { create as e, windowScheduler as t } from "@yornaath/batshit";
import { authApi as n } from "@maat/api-main";
//#region src/utils/permissionBatcher.ts
var r = e({
	fetcher: async (e) => {
		let t = await n.checkPermissions(e);
		return e.map((e) => ({
			slug: e,
			allowed: t[e] ?? !1
		}));
	},
	resolver: (e, t) => e.find((e) => e.slug === t),
	scheduler: t(50)
});
//#endregion
export { r as permissionBatcher };
